/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const SupplierDeliveryItemDTOStatusEnum = {
    Ordered: 'ORDERED',
    Shipped: 'SHIPPED',
    OutForDelivery: 'OUT_FOR_DELIVERY',
    Delayed: 'DELAYED',
    Delivered: 'DELIVERED',
    Cancelled: 'CANCELLED',
    Lost: 'LOST',
    ReturnedToSender: 'RETURNED_TO_SENDER',
    Refunded: 'REFUNDED',
    Unknown: 'UNKNOWN'
};
/**
 * Check if a given object implements the SupplierDeliveryItemDTO interface.
 */
export function instanceOfSupplierDeliveryItemDTO(value) {
    if (!('buyerOrderId' in value) || value['buyerOrderId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function SupplierDeliveryItemDTOFromJSON(json) {
    return SupplierDeliveryItemDTOFromJSONTyped(json, false);
}
export function SupplierDeliveryItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'buyerOrderId': json['buyerOrderId'],
        'status': json['status'],
        'statusText': json['statusText'] == null ? undefined : json['statusText'],
        'deliveredAt': json['deliveredAt'] == null ? undefined : (new Date(json['deliveredAt'])),
        'trackingId': json['trackingId'] == null ? undefined : json['trackingId'],
        'expectedDeliveryDate': json['expectedDeliveryDate'] == null ? undefined : (new Date(json['expectedDeliveryDate'])),
    };
}
export function SupplierDeliveryItemDTOToJSON(json) {
    return SupplierDeliveryItemDTOToJSONTyped(json, false);
}
export function SupplierDeliveryItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'buyerOrderId': value['buyerOrderId'],
        'status': value['status'],
        'statusText': value['statusText'],
        'deliveredAt': value['deliveredAt'] == null ? undefined : ((value['deliveredAt']).toISOString()),
        'trackingId': value['trackingId'],
        'expectedDeliveryDate': value['expectedDeliveryDate'] == null ? undefined : ((value['expectedDeliveryDate']).toISOString().substring(0, 10)),
    };
}
